import type { TopicRecommendation } from '../../types/inbox.types';

export type UseTopicRecommendationSectionProps = {
  recommendation?: TopicRecommendation | null;
  currentSubTopicId: string | null;
  onSelectSubTopic: (subTopicId: string) => void;
  onCreateNewTopicClick: () => void;
};

export function useTopicRecommendationSection(props: UseTopicRecommendationSectionProps) {
  const recommendation = props.recommendation;

  const hasExplanation = Boolean(recommendation?.explanation);
  const hesitations = recommendation?.hesitations || [];
  const hasHesitations = hesitations.length > 0;
  const shouldCreateNewTopic = Boolean(recommendation?.shouldCreateNewTopic);
  const suggestedNewTopicTitle = recommendation?.suggestedNewTopicTitle || null;
  const newTopicReason = recommendation?.newTopicReason || null;

  const hasRecommendation = Boolean(
    recommendation && (hasExplanation || hasHesitations || shouldCreateNewTopic)
  );

  function handleSelectHesitation(subTopicId?: string | null) {
    if (!subTopicId) {
      return;
    }
    props.onSelectSubTopic(subTopicId);
  }

  return {
    hasRecommendation,
    explanation: recommendation?.explanation || null,
    hesitations,
    hasHesitations,
    shouldCreateNewTopic,
    suggestedNewTopicTitle,
    newTopicReason,
    handleSelectHesitation,
  };
}
